import { getApiClient } from '@plandi/common'
import { components } from '@plandi/common/src/generated'
import { LeaveReviewPayload } from './profiles.types'

export const profilesApi = {
  uploadReviewImages: (reviews: FormData, locale: string) =>
    getApiClient(locale)
      .post<components['schemas']['ReviewImagesResourse']>(
        'v1/profiles/review/reviewsFiles',
        reviews
      )
      .then(({ data }) => data.data),

  leaveReview: (payload: LeaveReviewPayload, locale: string) =>
    getApiClient(locale)
      .post('v1/profiles/review/create', payload)
      .then(({ data }) => data.data),

  getProfileReviews: (profileId: number, locale: string) =>
    getApiClient(locale)
      .get<components['schemas']['ReviewListResourse']>(
        `v1/profiles/review/${profileId}`
      )
      .then(({ data }) => data)
}
